import { Grid } from '@material-ui/core';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import BaseButton from 'src/common/components/base-button';
import { IItemLookup } from 'src/common/interfaces/dtos/IItemLookup';
import { IElectronicJournalRecord } from 'src/common/interfaces/states/IElectronicJournalRecord';
import { AppState } from 'src/common/redux/configure-store';
import Pagination from 'src/pagination/pagination';
import { codeContainerStyles } from '../../common/components/code-container/components/code-container-styles';
import BottleReturnList from './bottle-return-list/bottle-return-list';

const pageSize = 8;

const BottleDepositReturnWindow: React.FC<IBottleDepositReturnProps> = (
  props: IBottleDepositReturnProps,
): JSX.Element => {
  const classes = codeContainerStyles();
  const { onAdd, onCancel, onFinish, itemsReturnedInCurrentTransaction } = props;
  const bottleReturnItemList = useSelector(
    (state: AppState): IItemLookup[] => state.bottleReturn.itemList,
  );
  const returnedItemList: IItemLookup[] = bottleReturnItemList.filter(item =>
    itemsReturnedInCurrentTransaction.find(i => i.ItemId === item.itemId),
  );
  const nonReturnedItemList = bottleReturnItemList.filter(list => !returnedItemList.includes(list));
  const sortedBottleReturnItemList = [...returnedItemList, ...nonReturnedItemList];
  const [currentPage, setCurrentPage] = useState<number>(1);
  const { t } = useTranslation();
  return (
    <Grid
      item
      container
      className={classes.bottleDepositContainer}
      data-testid='bottle-deposit-return'
    >
      <BottleReturnList
        listings={sortedBottleReturnItemList.slice(
          (currentPage - 1) * pageSize,
          currentPage * pageSize,
        )}
        itemsReturnedInCurrentTransaction={itemsReturnedInCurrentTransaction}
        onClick={onAdd}
      />
      <Grid container justifyContent='space-between' className={classes.bottleReturnPagination}>
        <Grid item>
          <Grid container justifyContent='center' className='fullHeight'>
            <Pagination
              currentPage={currentPage}
              totalPages={Math.ceil(sortedBottleReturnItemList.length / pageSize)}
              updateCurrentPageHandler={setCurrentPage}
              testIdPrefix={'bottle-return'}
            />
          </Grid>
        </Grid>
        <Grid
          item
          container
          justifyContent='center'
          className={classes.bottomRightButtons}
          wrap='nowrap'
        >
          <BaseButton
            className={classes.cancelButton}
            buttonType='white'
            onClick={onCancel}
            data-testid='bottle-deposit-cancel-button'
          >
            {t('Cancel')}
          </BaseButton>
          <BaseButton
            data-testid='bottle-return-submit-btn'
            className={classes.addButton}
            onClick={onFinish}
            disabled={itemsReturnedInCurrentTransaction.length === 0}
          >
            {t('Finish')}
          </BaseButton>
        </Grid>
      </Grid>
    </Grid>
  );
};

export interface IBottleDepositReturnProps {
  onAdd: (itemId: string) => void;
  onCancel: () => void;
  onFinish: () => void;
  itemsReturnedInCurrentTransaction: IElectronicJournalRecord[];
}

export default BottleDepositReturnWindow;
